import {fetchWithRetry} from '@/utils/fetchWithRetry';
import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import getGameId from '@/utils/getGameId';

export default async function logout(returnToSC?: boolean) {
  const headers = {};
  await addBrowserSideAppHeaders(headers);
  const response = await fetchWithRetry('/api/logout', {
    method: 'POST',
    headers,
  });

  if (returnToSC) {
    const gid = getGameId();
    const url = await response.text();
    window.location.replace(`${url}/mobile/games/${gid}`);
  }

  return response;
}
